import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/common/SectionHeading";
import { SERVICES } from "@/lib/data";

export default function ServicesSection() {
  return (
    <section className="py-24 sm:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <SectionHeading
            eyebrow="Our Services"
            title="Everything you need — from resume to onboarding."
            sub="Nine services engineered for international students, OPT/CPT candidates and H-1B professionals. One accountable partner across your entire US career journey."
          />
          <Link to="/services" className="font-inter text-sm text-white/70 hover:text-white inline-flex items-center gap-1.5">
            All services <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group relative rounded-3xl p-7 border border-white/5 bg-[#0d1428] hover:border-white/15 transition-colors overflow-hidden"
              data-testid={`service-card-${i}`}
            >
              <div className="absolute -top-20 -right-20 w-48 h-48 rounded-full blur-3xl opacity-0 group-hover:opacity-40 transition-opacity duration-500"
                style={{ background: "#10B981" }} />

              <div className="relative">
                <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-6"
                  style={{ background: "linear-gradient(135deg, rgba(30,58,138,0.35), rgba(16,185,129,0.3))", border: "1px solid rgba(255,255,255,0.08)" }}>
                  <s.icon className="w-5 h-5 text-white" strokeWidth={2} />
                </div>
                <p className="font-poppins text-white text-xl font-semibold mb-3">{s.title}</p>
                <p className="font-inter text-sm text-white/55 leading-relaxed mb-6">{s.desc}</p>
                <ul className="space-y-2">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 font-inter text-[13px] text-white/70">
                      <span className="w-1 h-1 rounded-full bg-[#10B981]" />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
